import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services';
import { AuthorizationService } from 'src/app/services/authorization.service';
import { MemberRoleEnum, UserDutyEnum } from 'src/enumerators';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css'],
})
export class SidebarComponent implements OnInit {
  userDutyEnum = UserDutyEnum;
  memberRoleEnum = MemberRoleEnum

  constructor(public _authService: AuthService, public authorizationService: AuthorizationService ) {}

  ngOnInit(): void {}

}
